// extracted by mini-css-extract-plugin
export var displayNone = "_jg-6";
export var imgContainer = "_jg-2";
export var overflowHidden = "_jg-3";
export var productInfoCardButtonContainer = "_jg-5";
export var productTitleText = "_jg-4";
export var rightArrow = "_jg-1";
export var rightArrowContainer = "_jg-0";